export enum SiteTitle {
  wtes = 'Juega a las loterias en linea - Trillonario.com',
  wten = 'Play the Lottery Online - WinTrillions.com',
  wtpt = 'Jogue na loteria online - Trilhardario.com',
  ltkes = 'Juega a las loterias en linea - Lottokings.com',
  ltken = 'Play the Lottery Online - Lottokings.com',
  ltkpt = 'Jogue na loteria online - Lotosena.com'
}
